import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import JoditEditor from 'jodit-react';
import SvgIcon from 'react-icons-kit';
import { bin } from 'react-icons-kit/icomoon/bin';
import { donationNotes, donationNotesInactive, monitoringTraceability } from '../../libs/services';

var Config = require('../../config');

class ModalNotes extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveNotes = this.saveNotes.bind(this);
		this.setContent = this.setContent.bind(this);
		this.showAllNotes = this.showAllNotes.bind(this);
		this.disableNote = this.disableNote.bind(this);

		this.state = {
			show: false,
			notes:"",
			config:{
				buttonsSM: ['bold', 'italic', 'underline', 'strikethrough', 'eraser', 'ul', 'ol', 'font', 'fontsize', 'indent', 'outdent'],
				readonly:false,
				language: "es",
				autofocus:true
			},
			all_notes:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount(){
		this.props.onRef(null)
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false, all_notes:false});
	}

	handleShow() {
		//this.props.getNotes();

		this.setState({
			show: true,
			notes:this.props.notes
		});	

		console.log(this.props);
	}

	async saveNotes(){
		if(this.state.notes.trim() === ""){
			swal('¡Atención!', "La nota no puede estar vacia", 'warning');
		}else{
			var obj = {};
			obj = {
				proces_type:"CLINIC_HISTORY",
				type:'NOTE',
				note:this.state.notes,
				//samples_id:this.props.state.sample !== undefined ?
							//this.props.state.sample_id : this.state.samples_id,
				//donation_id: null,
				donor_id: this.props.donor,
				offers_id: this.props.match.params.offers_id,
			}
			
			//lab_sections
			
			var response = await donationNotes(obj, this.props.waiting);
			if(response !== undefined){

				await this.props.getNotes(true, true);

				//Si las notas corresponden a entrevista de seguimiento epidemiologico
				if(this.props.match.path.includes("interview")){
					var obj = {
						process:'INTERVIEW',
						medical_staff_id: this.props.medical_staff.id,
						status: "ENTREVISTADO",
						epidemiological_monitoring_id:this.props.match.params.monitoring_id
					};

					response = await monitoringTraceability(obj);
					if(response !== undefined){
						this.setState({ show: false,notes:""});
					}
				}else{
					this.setState({ show: false,notes:""});
				}
			}
		}
	}

	//Evento de cambio en elementos formulario
	handleChange = (event) => {
		if(event.target.value.length <= 500){
			this.setState({[event.target.name]: event.target.value});	
		}
		
	}

	setContent(val){
		this.setState({notes: val});
	}

	showAllNotes(e){
		this.setState({all_notes: !this.state.all_notes});

		if(e.target.checked){
			this.props.getNotes(null, true);
		}else{
			this.props.getNotes(true, true);
		}
	}

	disableNote(e, id){
		e.preventDefault();

		swal({
			title: '¿Desea eliminar la nota?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, async (isConfirm)=> {
			if (isConfirm) {
				var response = await donationNotesInactive(id);
				if(response !== undefined){
					if(this.state.all_notes){
						this.props.getNotes(null, true);
					}else{
						this.props.getNotes(true, true);
					}
				}
			}
		});
	}

	render(){
		const { t } = this.props;
		
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_notes.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		{/*<textarea className="form-control" style={{height:"200px",width:"100%",resize:"none"}}
		        			value={this.props.notes} disabled />*/}
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12">
		        				<input type="checkbox" name="all_notes" id="all_notes" value={this.state.all_notes}
		        					checked={this.state.all_notes} onChange={(e)=>this.showAllNotes(e)} /> <span className="span-min">Ver todos</span>
		        			</div>
		        			<div className="col-xs-12">									
								<table className="table">
									<tbody style={{display:'block', height:'200px', overflowY:'auto'}}>
									{this.props.notes.map((note, i)=>
										<tr key={i} style={{width:'100%', display:'grid'}}>
											<td>
												<div className="col-xs-11">
													<div className="col-xs-12" style={{textAlign:'right'}}>
														{note.user_date}
													</div>
													<div className="col-xs-12">
														<div>{note.screen}</div>
														<div>{note.note}</div>	
													</div>
												</div>
												<div className="col-xs-1">
													{note.active &&
														<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
															<SvgIcon icon={bin}/>
														</button>
													}
												</div>

											</td>
										</tr>
									)}
									</tbody>
								</table>
							</div>
		        		</div>
		        		
		        		<div className="col-xs-12">
							<JoditEditor 
								ref={ref => this.editor = ref}
								value={this.state.content}
								config={this.state.config}
								tabIndex={1}
								id="notes"
								name="notes"
								onChange={newContent => this.setContent(newContent)}
								
							/>
							{/*<textarea className="form-control editor-note" style={{height:"200px",width:"100%",resize:"none"}} name="notes" 
								value={this.state.notes} id="notes" onChange={ this.handleChange }/>*/}
						</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveNotes}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalNotes);